/**
 * Translates Klaviyo Back In Stock button text
 * Observes DOM for dynamically loaded Klaviyo buttons and translates them
 */
(function() {
  'use strict';

  /**
   * Get translation from multiple sources
   */
  function getTranslation() {
    // First, try to get from FoxTheme.variantStrings
    if (window.FoxTheme && window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.notifyMe) {
      return window.FoxTheme.variantStrings.notifyMe;
    }

    // Second, try to get from a klaviyo-bis-trigger element (contains correct translation for current language)
    const triggerElement = document.querySelector('.klaviyo-bis-trigger');
    if (triggerElement && triggerElement.textContent.trim()) {
      return triggerElement.textContent.trim();
    }

    return null;
  }

  /**
   * Ensure product-card Klaviyo triggers always show notify-me copy
   */
  function hydrateProductCardTriggers() {
    const translation = getTranslation();
    if (!translation) {
      return;
    }

    document.querySelectorAll('.product-card__atc--sold-out .klaviyo-bis-trigger').forEach(function(trigger) {
      if (!trigger.textContent.trim()) {
        trigger.textContent = translation;
      }
    });
  }

  /**
   * Translates Klaviyo BIS button
   */
  function translateKlaviyoButton(button) {
    if (!button) {
      return false;
    }

    // Never translate Klaviyo modal close buttons (they often share generic Klaviyo reset classes)
    const ariaLabel = (button.getAttribute('aria-label') || '').trim().toLowerCase();
    if (ariaLabel === 'close dialog' || button.classList.contains('klaviyo-close-form')) {
      return false;
    }

    if (button.dataset.translated === 'true') {
      return false;
    }

    const translation = getTranslation();
    if (!translation) {
      return false;
    }

    // Check if button contains text that needs translation
    const buttonText = button.textContent.trim();
    
    // Always translate if text is different (even if already marked as translated)
    if (buttonText && buttonText !== translation) {
      button.textContent = translation;
      button.dataset.translated = 'true';
      return true;
    }

    // Mark as translated even if text matches (to avoid re-processing)
    if (buttonText === translation) {
      button.dataset.translated = 'true';
      return true;
    }

    return false;
  }

  /**
   * Find and translate all Klaviyo BIS buttons
   */
  function translateAllKlaviyoButtons() {
    // Look for buttons with Klaviyo BIS classes/attributes
    const selectors = [
      'button[data-a11y-identifier*="bis-button"]',
      '#klaviyo-bis-button-container button',
      '[data-a11y-identifier*="bis-button"] button'
    ];

    // Also check container directly
    const container = document.getElementById('klaviyo-bis-button-container');
    if (container) {
      const buttons = container.querySelectorAll('button');
      buttons.forEach(button => {
        translateKlaviyoButton(button);
      });
    }

    selectors.forEach(selector => {
      try {
        const buttons = document.querySelectorAll(selector);
        buttons.forEach(button => {
          // Only process actual button elements
          if (button.tagName === 'BUTTON') {
            translateKlaviyoButton(button);
          }
        });
      } catch (e) {
        // Ignore selector errors
      }
    });
  }

  /**
   * Initialize translation observer
   */
  function init() {
    // Wait for translation to be available
    const translation = getTranslation();
    if (!translation) {
      // If translation not available yet, wait and retry
      setTimeout(init, 200);
      return;
    }

    // Translate existing buttons immediately
    hydrateProductCardTriggers();
    translateAllKlaviyoButtons();

    // Observe DOM for dynamically added buttons
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Check if any added node is a button or contains buttons
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.tagName === 'BUTTON' || 
                  node.querySelector && node.querySelector('button[data-a11y-identifier*="bis-button"]')) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck) {
        // Use setTimeout to ensure button is fully rendered
        setTimeout(translateAllKlaviyoButtons, 50);
      }
    });

    // Start observing
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Also check periodically as a fallback (more aggressive)
    let checkCount = 0;
    let checkInterval = setInterval(function() {
      translateAllKlaviyoButtons();
      checkCount++;
      
      // Stop checking after 15 seconds or 30 attempts
      if (checkCount >= 30) {
        clearInterval(checkInterval);
      }
    }, 500);

    // Stop checking after 15 seconds
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 15000);

    // Listen for Klaviyo-specific events if available
    if (window.addEventListener) {
      window.addEventListener('klaviyo:loaded', translateAllKlaviyoButtons);
      window.addEventListener('klaviyo:bis:loaded', translateAllKlaviyoButtons);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 100);
    });
  } else {
    setTimeout(init, 100);
  }

  // Also run after delays to catch late-loading buttons
  setTimeout(init, 500);
  setTimeout(init, 1000);
  setTimeout(init, 2000);
})();
